import { render, staticRenderFns } from "./CookiesPolicy.html?vue&type=template&id=bac7a3e4&external"
import script from "./CookiesPolicy.ts?vue&type=script&lang=ts&external"
export * from "./CookiesPolicy.ts?vue&type=script&lang=ts&external"
import style0 from "./CookiesPolicy.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports